import { atom } from 'jotai';

// 是否在sports Tab页
export const isSportsActiveAtom = atom<boolean>(false);